"use client";

import React from "react";
import { Hexagon, Box, Layers, Check, ArrowRight, Target, Users } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const capabilityCategories = [{
  id: 1,
  title: "Athlete Intent Moments",
  iconName: "Target"
}, {
  id: 2,
  title: "Endurance Publisher Network",
  iconName: "Users"
}, {
  id: 3,
  title: "Audience Activation",
  iconName: "Layers"
}];
const capabilityFeatures = [{
  categoryId: 1,
  text: "Race Discovery & Registration Intent"
}, {
  categoryId: 1,
  text: "Training, Marathon & Triathlon Research"
}, {
  categoryId: 1,
  text: "Footwear, Gear & Nutrition Research"
}, {
  categoryId: 1,
  text: "Destination Race & Travel Interest"
}, {
  categoryId: 1,
  text: "Race Week, Live Event Engagement, Race Results & Recovery"
}, {
  categoryId: 2,
  text: "Sportstats"
}, {
  categoryId: 2,
  text: "RunGuides"
}, {
  categoryId: 2,
  text: "LetsRun"
}, {
  categoryId: 3,
  text: "First-Party Athlete Intent Signals"
}, {
  categoryId: 3,
  text: "Continuously Refreshed Audiences"
}, {
  categoryId: 3,
  text: "Athlete Interest & Intent Segmentation"
}, {
  categoryId: 3,
  text: "Meta Custom Audience Activation"
}, {
  categoryId: 3,
  text: "Campaign Performance Measurement"
}];
const iconMap: Record<string, React.ElementType> = {
  Hexagon: Hexagon,
  Box: Box,
  Layers: Layers,
  Target: Target,
  Users: Users
};
export default function DesignCapabilities() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222517" id="the-solution" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-5" style={{
      backgroundImage: `linear-gradient(to right, var(--color-border) 1px, transparent 1px), linear-gradient(to bottom, var(--color-border) 1px, transparent 1px)`,
      backgroundSize: '100px 100px'
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={headerRef} className={`max-w-4xl mb-16 transition-all duration-1000 transform ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="mb-8">
            <p className="font-default text-sm md:text-base font-bold uppercase tracking-wider text-primary mb-2">The Solution</p>
            <h2 className="font-default text-5xl md:text-6xl font-bold uppercase tracking-tight text-white">Endurance Athlete Audiences Built from Real Behavior</h2>
          </div>
          <p className="font-default text-muted-foreground text-lg md:text-xl max-w-3xl text-left">Go beyond broad sports-interest targeting. ESMG identifies endurance audiences through actual race research, training interests, gear exploration, event engagement and post-race activity across its publisher network.<br /><div><br /></div></p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {capabilityCategories.map((category, index) => {
          const Icon = iconMap[category.iconName];
          const features = capabilityFeatures.filter(f => f.categoryId === category.id);
          return <div key={category.id} data-index={index} className={`transition-all duration-700 transform ${isGridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} style={{
            transitionDelay: `${index * 150}ms`
          }}>
                <Card className="h-full bg-card/20 backdrop-blur-md border-border/40 rounded-lg hover:border-primary/40 transition-colors duration-300 relative overflow-hidden group">
                  {}
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary/0 via-primary to-primary/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  
                  <CardHeader className="pb-4">
                    <div className="mb-6 inline-flex items-center justify-center p-4 bg-secondary border border-border/50 shadow-lg relative rounded-md">
                      {}
                      <div className="absolute inset-0 bg-primary/20 translate-x-1 translate-y-1 -z-10 rounded-md" />
                      <Icon className="size-8 text-primary" strokeWidth={2} />
                    </div>
                    <CardTitle className="font-default text-2xl font-bold tracking-tight text-foreground">
                      {category.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-4">
                      {features.map((feature, fIndex) => <li key={fIndex} data-index={fIndex} className="flex items-start gap-3">
                          <Check className="size-5 text-primary shrink-0 mt-0.5" strokeWidth={3} />
                          <span className="font-default text-muted-foreground leading-snug">
                            {feature.text}
                          </span>
                        </li>)}
                    </ul>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-16 flex justify-center lg:justify-start">
          <Button asChild size="lg" className="rounded-md font-default font-bold uppercase tracking-wider bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg">
            
          </Button>
        </div>
      </div>
    </section>;
}